export const TechnicalStatuses = [
  'CREATED',
  'PROCESSED',
  'REPROCESS',
  'IN_ERROR',
  'ABANDON'
]
